import React from "react";
import { useLanguage } from "../../../contexts/LanguageContext";
import {
  ActiveIndicator,
  FlagIcon,
  LanguageCode,
  LanguageOption,
  SwitcherContainer,
} from "./LanguageSwitcherElements";

const LanguageSwitcher = () => {
  const { currentLanguage, supportedLanguages, changeLanguage } = useLanguage();
  const activeIndex = Math.max(
    0,
    supportedLanguages.findIndex((language) => language.code === currentLanguage)
  );

  return (
    <SwitcherContainer $count={supportedLanguages.length}>
      <ActiveIndicator
        aria-hidden
        $count={supportedLanguages.length}
        $index={activeIndex}
      />
      {supportedLanguages.map((language) => {
        const isActive = language.code === currentLanguage;
        return (
          <LanguageOption
            key={language.code}
            type="button"
            onClick={() => changeLanguage(language.code)}
            $active={isActive}
            aria-pressed={isActive}
            title={language.name}
          >
            <FlagIcon aria-hidden>{language.flag}</FlagIcon>
            <LanguageCode>{language.code.toUpperCase()}</LanguageCode>
          </LanguageOption>
        );
      })}
    </SwitcherContainer>
  );
};

export default LanguageSwitcher;
